(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("@material/tab-bar", [], factory);
	else if(typeof exports === 'object')
		exports["tab-bar"] = factory();
	else
		root["mdc"] = root["mdc"] || {}, root["mdc"]["tab-bar"] = factory();
})(this, function() {
return 